//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    calloutType: {
      type: String,
      required: true,
    },
    refundableDays: {
      type: Number,
      required: true,
    },
    isFreebie: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isMoneyBackGuarantee() {
      return this.calloutType === 'money-back';
    },
    isRedeemBy() {
      return this.calloutType === 'redeem-by';
    },
  },
};
